// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let WarningSection__Jsx3 = require("../../../uikit/reason/atoms/Sections/WarningSection__Jsx3.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let ConversationPageNotAnonymousWarning_conversationContext_graphql = require("../../../__generated__/ConversationPageNotAnonymousWarning_conversationContext_graphql.bs.js");

let convertFragment = ConversationPageNotAnonymousWarning_conversationContext_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationPageNotAnonymousWarning_conversationContext_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationPageNotAnonymousWarning_conversationContext_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, ConversationPageNotAnonymousWarning_conversationContext_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ConversationPageNotAnonymousWarning_conversationContext_graphql.node, convertFragment, fRef);
}

let ConversationContextFragment_forSalePropertyMatchingType_decode = ConversationPageNotAnonymousWarning_conversationContext_graphql.Utils.forSalePropertyMatchingType_decode;

let ConversationContextFragment_forSalePropertyMatchingType_fromString = ConversationPageNotAnonymousWarning_conversationContext_graphql.Utils.forSalePropertyMatchingType_fromString;

let ConversationContextFragment = {
  forSalePropertyMatchingType_decode: ConversationContextFragment_forSalePropertyMatchingType_decode,
  forSalePropertyMatchingType_fromString: ConversationContextFragment_forSalePropertyMatchingType_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function ConversationPageNotAnonymousWarning(props) {
  let __isNewConversation = props.isNewConversation;
  let isNewConversation = __isNewConversation !== undefined ? __isNewConversation : false;
  let conversationContext = RescriptRelay_Fragment.useFragment(ConversationPageNotAnonymousWarning_conversationContext_graphql.node, convertFragment, props.conversationContext);
  let hasAnonymousMatches;
  if (conversationContext !== undefined) {
    if (conversationContext.__typename === "AvailableConversationContext") {
      let match = conversationContext.context;
      hasAnonymousMatches = match.__typename === "BuyerNeedV5" ? Stdlib_Array.filterMap(match.currentUsersMatches.edges, v => {
          if (v === undefined) {
            return;
          }
          let match = v.node.source;
          let match$1 = match.forSalePropertyMatchingType;
          if (match$1 === "QUIET_ANONYMOUS") {
            return Primitive_option.some(Stdlib_Option.map(match.client, c => c.displayName));
          }
        }) : [];
    } else {
      hasAnonymousMatches = [];
    }
  } else {
    hasAnonymousMatches = [];
  }
  let agentDisplayName;
  if (conversationContext !== undefined && conversationContext.__typename === "AvailableConversationContext") {
    let match$1 = conversationContext.context;
    if (match$1.__typename === "BuyerNeedV5") {
      let match$2 = match$1.agent;
      agentDisplayName = match$2 !== undefined ? match$2.displayName : undefined;
    } else {
      agentDisplayName = undefined;
    }
  } else {
    agentDisplayName = undefined;
  }
  if (hasAnonymousMatches.length === 0) {
    return null;
  }
  let len = hasAnonymousMatches.length;
  let tmp;
  if (len !== 1) {
    tmp = len !== 0 ? `Your name remains hidden on ` + hasAnonymousMatches.length.toString() + ` of your matching sellers` : "";
  } else {
    let singleClientName = hasAnonymousMatches[0];
    let clientName = Stdlib_Option.getOr(singleClientName, "name unavailable");
    tmp = `Your name remains hidden on your seller "` + clientName + `"`;
  }
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsxs(WarningSection__Jsx3.make, {
      children: [
        isNewConversation ? JsxRuntime.jsx("div", {
            children: "This conversation will not be anonymous",
            className: "mb-2 font-bold"
          }) : null,
        tmp + ". However, " + (
          agentDisplayName !== undefined ? agentDisplayName + " will see your name" : "your name will be visible"
        ) + " in this conversation"
      ]
    }),
    className: "mt-2"
  });
}

let make = ConversationPageNotAnonymousWarning;

exports.ConversationContextFragment = ConversationContextFragment;
exports.make = make;
/* react/jsx-runtime Not a pure module */
